import getApiClient from '../../../plugins/api'

export default {
    checkAccess: function() {

    },

    updateResource(data){
        this.payables = data['hydra:member']
    },

    loadPayables: function() {
        const self = this,
            api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        api.get('payables')
            .then((result) => {
                self.payables = result.data
            })
            .catch((error) => {
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })

    }
}
